import styled from "styled-components";
import { colors } from "../../../../../theme/theme";

export const Empty = styled.div`
    margin-top: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;

    p { 
        margin-top: 30px;
        color: ${colors.greyscale.grey};
        font-size: 24px;
    }

`;